import { render, staticRenderFns } from "./VistaPedido.vue?vue&type=template&id=f9f03892"
import script from "./VistaPedido.vue?vue&type=script&lang=js"
export * from "./VistaPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports